"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = exports.IntegerFormatter = exports.DecimalFormatter = void 0;
const tslib_1 = require("tslib");
const NumberUtil_1 = tslib_1.__importDefault(require("../util/NumberUtil"));
class DecimalFormatter {
    constructor(decimalPlaces, optionalDecimals) {
        this.decimalPlaces = decimalPlaces;
        this.optionalDecimals = optionalDecimals;
    }
    format(value) {
        return NumberUtil_1.default.getLocaleStringWithDigits(value, this.optionalDecimals ? 0 : this.decimalPlaces, this.decimalPlaces);
    }
}
exports.DecimalFormatter = DecimalFormatter;
class IntegerFormatter {
    format(value) {
        return `${Math.round(value)}`;
    }
}
exports.IntegerFormatter = IntegerFormatter;
class NumberFormatter {
    static integer() {
        return new IntegerFormatter();
    }
    static decimal(decimalPlaces, optionalDecimals = false) {
        return new DecimalFormatter(decimalPlaces, optionalDecimals);
    }
}
exports.default = NumberFormatter;
//# sourceMappingURL=NumberFormatter.js.map